import { lazy } from 'react'
import PayClassificationsLoader from './pay-classifications/loader'
import ManagePayClassificationsLoader from './pay-classifications/manage/loader'
import AddPayClassificationLoader from './pay-classifications/add/loader'
import EditPayClassificationLoader from './pay-classifications/edit/loader'
import LeaveTypesLoader from './leave-types/loader'
import ManageLeaveTypesLoader from './leave-types/manage/loader'
import EditLeaveTypeLoader from './leave-types/edit/loader'
import AddLeaveTypeLoader from './leave-types/add/loader'

export default {
  PayClassifications: {
    Component: lazy(
      () => import('./pay-classifications/PayClassifications.Page')
    ),
    Loader: PayClassificationsLoader,

    Manage: {
      Component: lazy(
        () =>
          import('./pay-classifications/manage/ManagePayClassifications.Page')
      ),
      Loader: ManagePayClassificationsLoader,
    },

    Add: {
      Component: lazy(
        () => import('./pay-classifications/add/AddPayClassification.Page')
      ),
      Loader: AddPayClassificationLoader,
    },

    Edit: {
      Component: lazy(
        () => import('./pay-classifications/edit/EditPayClassification.Page')
      ),
      Loader: EditPayClassificationLoader,
    },
  },
  LeaveTypes: {
    Component: lazy(() => import('./leave-types/LeaveTypes.Page')),
    Loader: LeaveTypesLoader,

    Manage: {
      Component: lazy(
        () => import('./leave-types/manage/ManageLeaveTypes.Page')
      ),
      Loader: ManageLeaveTypesLoader,
    },

    Add: {
      Component: lazy(() => import('./leave-types/add/AddLeaveType.Page')),
      Loader: AddLeaveTypeLoader,
    },

    Edit: {
      Component: lazy(() => import('./leave-types/edit/EditLeaveType.Page')),
      Loader: EditLeaveTypeLoader,
    },
  },
}
